import { formatKickoffLabel } from "../../../utils/format";
import { readGameStatus } from "../../../utils/gameStatus";
import { gameStatusNote } from "../../../utils/situation";
import styles from "./GameMeta.module.css";

/**
 * The one line under a matchup that says when, or how far in.
 *
 * A ruled strip rather than loose text: it separates "who is playing" from
 * "when", and gives a card the horizontal rhythm it lacks when everything is
 * left-aligned. The wording is the same wherever a game appears, which is
 * the point of it living here.
 *
 * Four states, in the order they matter to someone deciding whether to open
 * the game: in progress, finished, off schedule, not started yet.
 */
const GameMeta = ({ game, status, className = "" }) => {
  if (!game) return null;

  const { live, final, offSchedule } = readGameStatus(game, status);

  const tone = live
    ? styles.live
    : offSchedule
      ? styles.offSchedule
      : final
        ? styles.final
        : "";

  return (
    <p className={`${styles.GameMeta} ${tone} ${className}`.trim()}>
      {live ? (
        <>
          <span className={styles.livePip} aria-hidden="true" />
          {game.statusDetail ?? "In progress"}
        </>
      ) : final ? (
        <>
          <i className="fa-solid fa-flag-checkered" aria-hidden="true" />
          {game.statusDetail ?? "Full time"}
        </>
      ) : offSchedule ? (
        <>
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
          {gameStatusNote(status ?? game.status)}
        </>
      ) : (
        <>
          <i className="fa-regular fa-clock" aria-hidden="true" />
          {formatKickoffLabel(game.kickoffAt)}
        </>
      )}
    </p>
  );
};

export default GameMeta;
